/** @jsx jsx */
import { Swiper, SwiperSlide } from "swiper/react";
import { useEffect, useState } from "react";
import { jsx } from "@emotion/react";
import "swiper/swiper-bundle.min.css";
import SwiperCore, { Autoplay, Keyboard, Navigation, Pagination } from "swiper";
import { Col, Container, Row } from "react-bootstrap";
import { carouselLojaHomeSwipe } from "../assets/styles/Slider.styles";
import ImgLoja1 from '../assets/images/LP-arabe/loja/loja-1.png'
import ImgLoja2 from '../assets/images/LP-arabe/loja/loja-2.png'
import ImgLoja3 from '../assets/images/LP-arabe/loja/loja-3.png'
import ImgLoja4 from '../assets/images/LP-arabe/loja/loja-4.png'
import ImgLoja5 from '../assets/images/LP-arabe/loja/loja-5.png'
import ImgLoja6 from '../assets/images/LP-arabe/loja/loja-6.png'
import ImgLoja7 from '../assets/images/LP-arabe/loja/loja-7.png'
import ImgLoja8 from '../assets/images/LP-arabe/loja/loja-8.png'

SwiperCore.use([Pagination]);

const SliderHome = () => {
    const [isMobile, setIsMobile] = useState(false)
        useEffect(() => {
          const handleResize = () => {
            setIsMobile(window.innerWidth < 600)
          }
          if (typeof window !== 'undefined') {
            setIsMobile(window.innerWidth < 600)
            window.addEventListener('resize', handleResize)
          }
          return () => {
            if (typeof window !== 'undefined') {
              window.removeEventListener('resize', handleResize)
            }
          }
        }, [])
  return (
    <section style={{position: 'relative', overflow: 'hidden' }} css={carouselLojaHomeSwipe}>
      <Container>
        <Row>
          <Col data-aos="fade-left" data-aos-duration="1500" data-aos-easing="ease-in-sine" md={12} className="slideCarrousel order-1 order-md-2">
            <Swiper
              slidesPerView={'auto'}
              spaceBetween={isMobile ? 0 : 30}
              loop={true}
              keyboard={{
                enabled: true,
              }}
              pagination={{
                  clickable: true,
              }}
              autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                }}
              mousewheel={true}
              modules={[Autoplay,Keyboard, Pagination, Navigation]}
                 className="mySwiper"

            >
              <SwiperSlide>
                <div>
                  <img className="img-estrutura" src={ImgLoja1} />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div>
                  <img className="img-estrutura" src={ImgLoja2} />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div>
                  <img className="img-estrutura" src={ImgLoja3} />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div>
                  <img className="img-estrutura" src={ImgLoja4} />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div>
                  <img className="img-estrutura" src={ImgLoja5} />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div>
                  <img className="img-estrutura" src={ImgLoja6} />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div>
                  <img className="img-estrutura" src={ImgLoja7} />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div>
                  <img className="img-estrutura" src={ImgLoja8} />
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
        <Row>
          <Col lg={12} md={12} sm={12}>
            <div style={{ textAlign: 'center' }}>
              <a className="button-link" href='https://loja.escolaarabebrasileira.com.br/' target="_blank">
                Acesse a loja
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SliderHome;
